// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Headers
 */
/*
  Base Sizing
 */
/*
  Colors
 */
/*
  Border Radii Sizes
 */
/*
  Shadows
 */
/*
  Global Styles
 */
html[data-v-fbac9bec] {
  font-size: 10px;
}

/**
 * COODE Header Colors
 */
.pml-type-ahead[data-v-fbac9bec] {
  border-radius: 4px;
  border: 1px solid #adadad;
  background-color: #ffffff;
  position: relative;
  display: flex;
  align-items: center;
  user-select: none;
}
.pml-type-ahead[data-v-fbac9bec]:hover {
  border-color: #0476D9;
}
.pml-type-ahead--disabled[data-v-fbac9bec] {
  background-color: #f5f5f5;
}
.pml-type-ahead--disabled[data-v-fbac9bec]:hover {
  border-color: #adadad;
}
.pml-type-ahead__input[data-v-fbac9bec] {
  padding: 0 12px;
  line-height: 16px;
  height: 38px;
  color: #4a4a4a;
  background-color: transparent;
  border: 0;
  outline: none;
  width: 100%;
}
.pml-type-ahead__loading-icon[data-v-fbac9bec] {
  left: -1.6rem;
}
.pml-type-ahead__results[data-v-fbac9bec] {
  top: 48px;
  border-radius: 4px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.16);
  padding: 0;
  margin: 0;
  background-color: #ffffff;
  width: 100%;
  position: absolute;
  z-index: 100;
  min-height: 1.6rem;
  max-height: 35.2rem;
  overflow: auto;
}
.pml-type-ahead__results__item[data-v-fbac9bec] {
  font-size: 14px;
  padding: 10px 12px;
  line-height: 1.5;
  display: flex;
  flex-direction: column;
}
.pml-type-ahead__results__item[data-v-fbac9bec]:hover {
  background-color: rgba(4, 118, 217, 0.2);
}
.pml-type-ahead__results__item--selected[data-v-fbac9bec] {
  background-color: rgba(4, 118, 217, 0.1);
  font-weight: bold;
}
.pml-type-ahead__results__item__label--secondary[data-v-fbac9bec] {
  font-size: 1.92rem;
}
.pml-type-ahead__message[data-v-fbac9bec] {
  padding: 12px 12px;
  top: 48px;
  font-size: 14px;
  border-radius: 4px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.16);
  text-align: center;
  background-color: #ffffff;
  width: 100%;
  position: absolute;
  z-index: 1;
}
.chip[data-v-fbac9bec] {
  margin: 0 4px 4px 0;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
